import { getModule10FromCodePart, validateModule10 } from '../validateModule10';

export const getCipDigitableLineFromBarCode = (barCode: string) => {
  const bank = barCode.substring(0, 3);
  const currency = barCode.substring(3, 4);

  const firstOpenField = barCode.substring(19, 24);
  const firstField = bank + currency + firstOpenField;
  const firstDigit = getModule10FromCodePart(firstField);

  const secondOpenField = barCode.substring(24, 34);
  const secondDigit = getModule10FromCodePart(secondOpenField);

  const thirdOpenField = barCode.substring(34, 44);
  const thirdDigit = getModule10FromCodePart(thirdOpenField);

  const generalDigit = barCode.substring(4, 5);
  const maturityFactor = barCode.substring(5, 9);
  const value = barCode.substring(9, 19);
  const digitableLine = `${firstField}${firstDigit}${secondOpenField}${secondDigit}${thirdOpenField}${thirdDigit}${generalDigit}${maturityFactor}${value}`;

  return digitableLine;
};

export const validateCipDigitableLine = (barCode: string) => {
  const barCodeWithoutSpacesOrHyphens = barCode.replace(/[ -.]/g, '');

  const is47Digits = /^\d{47}$/.test(barCodeWithoutSpacesOrHyphens);
  if (!is47Digits) {
    return 'Código de barras inválido';
  }

  const codeParts = [
    barCodeWithoutSpacesOrHyphens.substring(0, 10),
    barCodeWithoutSpacesOrHyphens.substring(10, 21),
    barCodeWithoutSpacesOrHyphens.substring(21, 32),
  ];

  const areAllCodePartsValid = codeParts.every(part => validateModule10(part) === undefined);

  return areAllCodePartsValid ? undefined : 'Código de barras inválido';
};



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/validator/validateBarcode/validateCipDigitableLine/index.ts